import React, { Component } from "react";
import FetchCall, { partnerApi, updategallery } from './../../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
import jQuery from 'jquery'; import {
  Collapse,
  CardBody,
  Card,
  CardHeader
} from 'reactstrap';

import 'react-notifications/lib/notifications.css';

import {NotificationContainer, NotificationManager} from 'react-notifications';

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_data: JSON.parse(localStorage.getItem("user_data")),
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      user_type: 0,
      access: [],
      photos_arr: [],
      delete_array: [],
      edit_image: '',
      url: '',
      image_count: 0,
      photos_arr_length: 0,
      showupload: false, imagename: '', newimage: '', removeindex: '',
      attachment_file: [],
      attachment_file_length: 0,
      attachment_fileName: [],
      tempBanner: '',
      active_status: 0,
      main_id: 0,
      main_access: '',
      collapse: 0,
      page_data: [],
      btnDisabled: false
    }
    this.validator = new SimpleReactValidator({
      validators: {
        checkExist: {  // name the rule
          message: 'The :attribute field is required.',
          rule: (val, params, validator) => {
            if (val == '' && this.state.edit_image == '') {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        }
      }
    });
    this.loadFile = this.loadFile.bind(this);
    this.getgallery;
    this.getGallery();
    this.toggle = this.toggle.bind(this);
  }
  toggle(event) {
    this.setState({
      collapse: this.state.collapse === Number(event) ? -1 : Number(event)
    });
  }
  componentDidMount() {
    if (this.state.authentication == true) {
      this.setState({
        access: this.state.user_data.current_category.split(','),
        user_type: this.state.user_data.user_type
        // access: [1]
      });
    }
  }
  getGallery = () => {
    const { user_type, login_id, set_id } = this.state.user_data;
    let req = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      url: 'getGalleryNew'
    });
    partnerApi(req).then((response) => {

      if (response.status === 1) {
        let data = response.result;
        let imagecnt = data.max_gallery;
        if (data.plan_id == 0) {
          imagecnt = user_type == 1 ? 8 : 7;
        }
        this.setState({
          page_data: data.master_data,
          active_status: response.result.active_status,
          image_count: imagecnt
        });
      }
    })
  }
  getgallery = () => {
    const { user_type, login_id, is_completd, current_plan, current_category, uid, branch_id } = this.state.user_data;
    let req = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      branch_id: branch_id,
      uid: uid,
      is_completd: is_completd,
      category: current_category,
      url: 'getContactData'
    });
    partnerApi(req).then((response) => {

      if (response.status === 1) {
        let data = response.result;
        let imagecnt = data.image_count;
        if (current_plan == 0) {
          imagecnt = user_type == 1 ? 8 : 7;
        }
        this.setState({
          attachment_file: data.photo_arr,
          active_status: data.active_status,
          main_id: data.main_id ? data.main_id : 0,
          main_access: data.main_access ? data.main_access : 0,
          url: data.url,
          image_count: imagecnt,
          edit_image: data.banner_image_up,
        });
      }
      console.log(this.state.photos_arr);
    })
  }
  loadFile(e, index,image_count) {
    var files = e.target.files
    let page_data = this.state.page_data;
    this.setState({ attachment_file_length: files.length })
    if (files.length > 0) {
      let toastr = window.toastr.warning;
      let errormsg = 'To upload more than ' + image_count + ' Image, Upgrade your plan';
      if (files.length <= image_count) {
        jQuery('.upload-space').addClass('hide')
        jQuery('.upload-thumb').removeClass('hide')
        var fileArra = page_data[index].attachment_file
        let total = fileArra.length + files.length;
        if (total <= image_count) {
          let err = '';
          for (var i = 0; i < files.length; i++) {
            if (e.target.files[i].size <= 1000000)
              fileArra.push(e.target.files[i])
            else
              err = 'Image should be less than 1 MB';
          }
          page_data[index].attachment_file = fileArra
          this.setState({
            page_data
          });
          if (err)
            NotificationManager.error(err);
        } else {
          NotificationManager.error(errormsg);
          
        }
      } else {
        NotificationManager.error(errormsg);
         
      }

    }
  }
  removeImage = (e, index) => {
    let page_data = this.state.page_data;
    console.log('delete_array', page_data[index], e)
    var delete_array = page_data[index].delete_array ? page_data[index].delete_array : [];
    delete_array.push(e);
    console.log('delete_array after', page_data[index])
    const updated = page_data[index].attachment_file.filter(item => item.name != e);
    page_data[index].delete_array = delete_array;
    page_data[index].attachment_file = updated;
    console.log('delete_array main', page_data[index])
    this.setState({
      page_data
    })
  }
  handleFile = (e, index) => {
    const propName = e.target.name;
    const files = e.target.files[0];
    let page_data = this.state.page_data;
    page_data[index]['newimage'] = files;
    this.setState({ page_data });
    const reader = new FileReader();
    let img = '';
    let THIS = this;
    reader.addEventListener("load", function () {
      // convert image file to base64 string
      img = reader.result;
      page_data[index]['tempBanner'] = reader.result;
      THIS.setState({
        page_data
      });
    }, false);

    if (files) {
      reader.readAsDataURL(files);
      console.log('img1', img);
    } else {
      page_data[index]['tempBanner'] = '';
      THIS.setState({
        page_data
      });
    }


  };
  render() {
    this.validator.purgeFields();
    const { access, user_type, collapse, page_data } = this.state;
    console.log('page_data', page_data)
    return (
      <React.Fragment>
         <div class="category_block">

<div class="titleline">
  <h4>Gallery</h4>
  <span>Manage your gallery images</span>
</div>

        {page_data.map((item, index) => {
          let lbl_banner = item.cid == 8 ? 'Event Poster if any can be uploaded here' : '';
          return (
            <div className="eachblockgap">
              <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
              

              <CardHeader onClick={() => this.toggle(index)} data-event={index} className={item.set_id!=1?"branchcss":"maincss"}>
                  <div class="infoBoxColor">
                        <div class="org_item">
                        <div class="label_n">Category:</div>
                        <div class="item_n">{item.category_name}</div>
                        </div>
                        <div class="org_item">
                        <div class="label_n">Inst/Org Name:</div>
                        <div class="item_n item_n_name">{item.organisation_name}</div>
                        </div>
                        <div class="org_item">
                        <div class="label_n">Sub Category</div>
                        <div class="item_n">{item.sub_category_name ? item.sub_category_name : ''}</div>
                        </div>
                        <div class="org_item">
                        <div class="label_n">Type:</div>
                        <div className={item.set_id!=1?"item_n branchtext":"item_n"}>{item.set_id!=1?"Branch":"HQ"}</div>
                        </div>
                    </div>
                        {collapse !== index ? (
                    <div class="centeredexpcolbtn"><span className=''>
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        </span></div>
                        ) : (
                            <div class="centeredexpcolbtn"><span className=''>
                            <i class="fa fa-minus" aria-hidden="true"></i>
                            </span></div>
                        )}
                    <br/>

              </CardHeader>
              <Collapse isOpen={collapse === index}>
                <CardBody className='panel-body'>

                <h3 className="page-header">{item.organisation_name} <span style={{fontSize:"10px"}}><b>{item.set_id==3?"Branch":""}</b></span></h3>
                <p className='mar-btm'>{item.address}</p>
             

                  {item.is_active == 0 ?
                    (
                      <div className='row mar-btm'>
                        <div class="form-group col-md-12">
                          <h3 className='text-center'>Upgrade/Renewal to update the Data</h3>
                        </div>
                      </div>
                    ) :
                    (
                      <form onSubmit={(e) => this.submitForm(e, index)}>
                        <div class="box-shadow-custom">
                          <div class="row">
                            <div className="form-group col-md-6 mar-btm" style={{ minHeight: 'unset' }}>
                              <label>
                                Banner Image {lbl_banner && '(' + lbl_banner + ')'} <span className="astrick">* (JPG, PNG in 560X250 pixels)</span>
                              </label>
                              <input
                                type="file"
                                name="newimage"
                                accept="image/x-png,image/gif,image/jpeg"
                                onChange={(e) => this.handleFile(e, index)}
                                className="form-control mar-btm"
                              />
                            </div>
                            {(item.edit_image != '' || item.tempBanner != '') &&
                              (
                                <div className="col-md-12 pad-hor-no">
                                  <div class="col-sm-4" id="edit_image">
                                    <img src={item.tempBanner ? item.tempBanner : item.edit_image} alt="Img" class="img-thumbnail" />

                                  </div>
                                </div>
                              )
                            }
                            <div className="upload-wizard-wrap col-md-12">
                              <div>
                                <div class="col-md-12 float-left mt-4 pad-no">
                                  <label>
                                    Gallery Images <span className="astrick">* (JPG, PNG in 980X360 pixels)</span>
                                  </label>
                                </div>

                                <div class="col-md-12 float-left mt-4 pad-no">

                                  <div class="col-md-12 margin-bottom-mobile-account float-left image-upload">
                                    <div className='upload-wizard'>
                                      <div className='upload-thumb'>
                                        <ul className='list-inline'>
                                          {item.attachment_file.map((file_data, i) => {

                                            var file_url;
                                            let url = file_data.image_thumb ? file_data.image_thumb : '';
                                            if (url != '') {
                                              file_url = file_data.image_thumb;
                                            } else {
                                              file_url = URL.createObjectURL(file_data);
                                            }
                                            if (file_data.type === 'application/pdf') {
                                              return (
                                                <li className='previewImg'>
                                                  <div className='thumb-img'>
                                                    <img
                                                      src={file_url}
                                                      alt='image'
                                                      title={file_data.name}
                                                    />
                                                  </div>

                                                  <a href='javascript:;' className='del-btn' onClick={(e) => {
                                                    this.removeImage(file_data.name, index)
                                                  }}>
                                                    <img
                                                      src={'../assets/images/close-icon-white.svg'}
                                                      alt='delete'
                                                    />
                                                  </a>
                                                </li>
                                              )
                                            } else {
                                              return (
                                                <li className='previewImg'>
                                                  <div className='thumb-img'>
                                                    <img
                                                      src={file_url}
                                                      alt='image'
                                                      title={file_data.name}
                                                    />
                                                  </div>
                                                  {/* <span className='file-name'>{file_data.name}</span> */}
                                                  <a
                                                    href='javascript:;'
                                                    className='del-btn'
                                                    onClick={(e) => {
                                                      this.removeImage(file_data.name, index)
                                                    }}
                                                  >
                                                    <img
                                                      src={'../assets/images/close-icon-white.svg'}
                                                      alt='delete' />
                                                  </a>
                                                </li>
                                              )
                                            }
                                          })}
                                          {item.attachment_file.length <= item.image_count && (
                                            <li className='addMore'>
                                              <input
                                                type='file'
                                                name='imgInp[]'
                                                id='imgInp2'
                                                className='add_img'

                                                onChange={(e) => this.loadFile(e, index, item.image_count)}
                                                accept="image/x-png,image/gif,image/jpeg"
                                              />
                                              <a href='javascript:;' className='add-more'>
                                                <div>
                                                  <img src={'../assets/images/upload-icon.svg'} alt='icon' />
                                                  Add more
                                                </div>
                                              </a>
                                            </li>
                                          )}

                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div className=''>
                          <h5 className='astrick'><b>Notes</b></h5>
                          <ul>
                            <li>
                              {`${item.plan_name} Upto ${item.image_count} images can be uploaded where each image < 1MB`}
                            </li>
                            <li>
                              Images uploaded in banner and gallery will be published once Admin approves.
                            </li>
                          </ul>
                        </div>

                        <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
                            <button type='submit' id="btnSubmit"
                            className="btn btn-primary btn-sm" disabled={this.state.btnDisabled}>
                            Submit Gallery info
                            </button>
                        </div>
                      </form>
                    )}
                </CardBody>
              </Collapse>
              </Card>
            </div>
          )
        })}
        </div>
        <NotificationContainer/>
      </React.Fragment >
    );
  }
  submitForm = (e, index) => {
    e.preventDefault();
    this.setState({
      btnDisabled: true
    })
    const { user_type, login_id } = this.state.user_data;
    let page_data = this.state.page_data[index];
    let request = {
      user_type: user_type,
      login_id: login_id,
      active_status: this.state.active_status,
      data: JSON.stringify(page_data),
      delete_array: page_data.delete_array,
      images: page_data.newimage,
      photos: page_data.attachment_file ? page_data.attachment_file : []
    };

    updategallery(request).then(res => {
      let toastr = '';
      this.setState({
        btnDisabled: false
      })
      if (res.status === 1) {
       
        NotificationManager.success(res.message);
        /*
        setTimeout(function () {
          window.location.reload();
        }, 1000);
        */
      } else {
        
        NotificationManager.error(res.message);
        
      }
    });
  };
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/other_info/GalleryV3.jsx